// terraform/posthog reads this file and creates a PostHog flag for every quoted
// F- or C- key it finds, in the prod project. Removing a key here deletes the
// flag on the next apply. Do not quote flag keys in comments.

export const posthogFeatureFlags = [
  "F-trigger-policy",
  "F-automation-milestone-triggers",
  "F-async-bulk-actions",
  "F-creator-tags",
  "F-new-collabs-groups",
  "F-ask-unbox",
  "F-total-gmv-hidden-collab-groups",
  "F-home-setup-checklist",
  "F-workspace-reports",
  "F-allow-old-safety",
  "F-rules-dashboard",
  "F-affiliate-data-pack",
  "F-ask-drawer-redesign",
  "F-self-serve-add-merchant",
  "F-mfa",
] as const;

export const remoteConfigKeys = ["C-banner", "C-login-banner"] as const;

export type PosthogFeatureFlag = (typeof posthogFeatureFlags)[number];

export type RemoteConfigKey = (typeof remoteConfigKeys)[number];

/** What a flag resolves to outside PostHog when nobody has set it. */
export const UNSET_FEATURE_FLAG = true;

export type FeatureFlagOverrides = Partial<Record<PosthogFeatureFlag, boolean>>;

/** A key the registry no longer declares, or a non-boolean value, is left out. */
export const parseFeatureFlagOverrides = (raw: string | null | undefined): FeatureFlagOverrides => {
  if (!raw) return {};
  try {
    const parsed: unknown = JSON.parse(raw);
    if (typeof parsed !== "object" || parsed === null) return {};
    return Object.fromEntries(
      posthogFeatureFlags.flatMap((key) => {
        const value = (parsed as Record<string, unknown>)[key];
        return typeof value === "boolean" ? [[key, value]] : [];
      }),
    );
  } catch {
    // Malformed JSON is treated the same as nothing set.
    return {};
  }
};
